var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.39688 0.896875 0.5 2 0.5H14C15.1031 0.5 16 1.39688 16 2.5V12.5C16 13.6031 15.1031 14.5 14 14.5H2C0.896875 14.5 0 13.6031 0 12.5V2.5ZM10.1187 5.82812C9.97812 5.62187 9.74687 5.5 9.5 5.5C9.25313 5.5 9.01875 5.62187 8.88125 5.82812L6.1625 9.81563L5.33437 8.78125C5.19062 8.60312 4.975 8.5 4.75 8.5C4.525 8.5 4.30625 8.60312 4.16563 8.78125L2.16563 11.2812C1.98438 11.5063 1.95 11.8156 2.075 12.075C2.2 12.3344 2.4625 12.5 2.75 12.5H5.75H6.75H13.25C13.5281 12.5 13.7844 12.3469 13.9125 12.1C14.0406 11.8531 14.025 11.5562 13.8687 11.3281L10.1187 5.82812ZM3.5 5.5C3.89782 5.5 4.27936 5.34196 4.56066 5.06066C4.84196 4.77936 5 4.39782 5 4C5 3.60218 4.84196 3.22064 4.56066 2.93934C4.27936 2.65804 3.89782 2.5 3.5 2.5C3.10218 2.5 2.72064 2.65804 2.43934 2.93934C2.15804 3.22064 2 3.60218 2 4C2 4.39782 2.15804 4.77936 2.43934 5.06066C2.72064 5.34196 3.10218 5.5 3.5 5.5Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPrice);
export default __webpack_public_path__ + "static/media/photo-price.6d194a01eef5842bc699231568fbfe8e.svg";
export { ForwardRef as ReactComponent };